import { toCanvas } from 'html-to-image';

export const LABEL_EXPORT_WIDTH_PX = Math.round((10 / 2.54) * 300);
export const LABEL_EXPORT_HEIGHT_PX = Math.round((15 / 2.54) * 300);

/**
 * Captura o nó da etiqueta como PNG (10×15 cm a 300 DPI para impressão).
 * Adiciona temporariamente a classe .label-paper--export ao nó.
 */
export async function exportLabelPaperToPng(node, fileBasename = 'etiqueta') {
  if (!node) {
    throw new Error('Etiqueta não encontrada para exportar.');
  }
  node.classList.add('label-paper--export');
  try {
    await new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });

    const w = node.offsetWidth;
    const h = node.offsetHeight;
    if (!w || !h) {
      throw new Error('Não foi possível medir a etiqueta para exportar.');
    }
    const pixelRatio = Math.max(
      LABEL_EXPORT_WIDTH_PX / w,
      LABEL_EXPORT_HEIGHT_PX / h
    );

    const sourceCanvas = await toCanvas(node, {
      width: w,
      height: h,
      canvasWidth: w,
      canvasHeight: h,
      pixelRatio,
      backgroundColor: '#fafafa',
      cacheBust: true,
      skipAutoScale: true
    });

    const out = document.createElement('canvas');
    out.width = LABEL_EXPORT_WIDTH_PX;
    out.height = LABEL_EXPORT_HEIGHT_PX;
    const ctx = out.getContext('2d');
    if (!ctx) {
      throw new Error('Não foi possível criar o contexto da imagem.');
    }
    ctx.fillStyle = '#fafafa';
    ctx.fillRect(0, 0, out.width, out.height);
    const sw = sourceCanvas.width;
    const sh = sourceCanvas.height;
    const dw = LABEL_EXPORT_WIDTH_PX;
    const dh = LABEL_EXPORT_HEIGHT_PX;
    const almostSameSize =
      Math.abs(sw - dw) <= 2 && Math.abs(sh - dh) <= 2;
    ctx.imageSmoothingEnabled = !almostSameSize;
    if (ctx.imageSmoothingEnabled) {
      ctx.imageSmoothingQuality = 'high';
    }
    ctx.drawImage(sourceCanvas, 0, 0, sw, sh, 0, 0, dw, dh);

    const dataUrl = out.toDataURL('image/png');
    const link = document.createElement('a');
    const name = String(fileBasename).replace(/[^\w-]/g, '_') || 'etiqueta';
    link.download = `etiqueta-${name}.png`;
    link.href = dataUrl;
    link.click();
  } finally {
    node.classList.remove('label-paper--export');
  }
}
